document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  const productTitleDiv = document.querySelector(".product__title h1");
  if (productTitleDiv) {
    console.log("Product title found:", productTitleDiv.innerText);

    if (productTitleDiv.innerText.includes("|")) {
      const [title, dimensions] = productTitleDiv.innerText.split("|");
      productTitleDiv.innerHTML = `${title.trim()} <span class="title-dimensions">${dimensions.trim()}</span>`;
      console.log("Dimensions added:", dimensions.trim());
    } else {
      console.log("No dimensions found in the title.");
    }
  } else {
    console.log("Product title not found.");
  }
});
